// extracted by mini-css-extract-plugin
export default {"CalanderDivStyle":"DateDropdown_CalanderDivStyle__CXtlx"};